<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title}}</myhead>
  <div v-if="typeid==3">
    <div class="pad14 mb80 size14 b500 line24">
      <div v-html="agreement"></div>
    </div>
    <div class="fixed l r b pad14 mb30">
      <van-button round block type="primary" @click="next">我已了解，开始考核</van-button>
    </div>
  </div>
  <div v-if="typeid==4">
    <div class="pad14 mb80 size14 b500 line24">
      <div v-html="agreement"></div>
    </div>
    <div class="fixed l r b pad14 mb30">
      <van-button round block type="primary" @click="next">我已了解</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Agreement',
  data(){
    return {
      typeid:3,
      agreement:'',
    }
  },
  watch:{
  },
  methods:{
    next(){
      if(this.typeid==3){
        this.$router.push({ path:'/assess'})
      }else if(this.typeid==4){
        this.$router.push({path:'/register/status',query:{type:'waiting'}})
      }
    }
  },
  created(){
    let {typeid} = this.$route.query;
    if(typeid){ this.typeid = typeid }
    this.ajax.post("api/getagreement",{typeid:this.typeid}).then(({data})=>{
      this.agreement = data.content;
    })
  }
}
</script>

<style>
</style>
